export enum OrderStatusEnum {
  null, // index 0 doesn't exist in table status
  PENDIENTE,
  PROCESSO,
  TERMINADO,
  ENTREGADO,
}
